// src/utils/apiConfig.js
import axios from "axios";

export const customerApi = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_URL,
  withCredentials: true,
});


 

